import { getStringErrors, getValidationErrorDictionary, getValidationErrors } from "../../../../logic/ValidationChecks/Validation";
import { Shift } from "../../../../stores/models/Shift";
import { ValidationCheck } from "../../../../stores/models/ValidationCheck";
import { ValidationError } from "../../../../stores/models/ValidationError";
import { IAdminVolunteerRegistrationFlowValues } from "../_interfaces/IAdminVolunteerRegistrationFlowValues";
import { VolunteerRegistrationFlowExternalState } from "../_interfaces/IAdminVolunteerRegistrationStepTypeValues";

type StepContext = IAdminVolunteerRegistrationFlowValues & VolunteerRegistrationFlowExternalState;

const validationChecks: (context: StepContext) => ValidationCheck<StepContext>[] =
    (context) => {
        let slotsRemainingErrors = [] as string[];
        if (context.offsetsTableController) {
            slotsRemainingErrors = context.offsetsTableController.records.selectedOptions.map(shiftInstance => {
                const shift = new Shift(shiftInstance);
                if (!shift.unlimitedSlots && context.volunteerIds.length > shift.slotsLeft) {
                    const repetitionPattern = shift.repetitionPattern;
                    return repetitionPattern.formattedStartDate + ", " + repetitionPattern.formattedTime;
                }
                return "";
            }).filter(error => error !== "");
        }

        return [{
            name: 'Offset(s) selected',
            condition: (context: StepContext) => {
                return context.offsets.length > 0;
            },
            error: new ValidationError('You must select at least one shift.', ['offsets'])
        }, {
            name: 'Enough slots remaining',
            condition: (context: StepContext) => {
                return slotsRemainingErrors.length === 0
            },
            error: new ValidationError('There are not enough remaining slots for the following shifts:\n\n' + slotsRemainingErrors.join("\n"), ['offsets'])
        }]
    };

export const AdminVolunteerRegistrationOffsetValidation = (context: StepContext) => {
    return {
        errors: getStringErrors(getValidationErrorDictionary(validationChecks, context)),
        valid: getValidationErrors(validationChecks, context).length === 0
    }
}